import { httpClient } from "../../../shared/api/httpClient"
import type {
    UsuarioBuscarRequest,
    UsuarioCrearResult,
    UsuarioIdRequest,
    UsuarioMostrarResult,
    UsuarioSimpleResult,
    UsuariosResult,
} from "../types/usuarios.types"

// Grupos, catálogos y rutas de acceso del usuario.
export {
    usuarioAsignarGrupos,
    grupoMostrarGruposPorUsuario,
    usuarioObtenerCompaniasYSucursales,
    usuarioObtenerRutasDeAcceso,
} from "./usuariosAcceso.api"
// Contraseña y foto del usuario.
export {
    usuarioCambiarContrasenia,
    usuarioReiniciarContraseña,
    mostrarFoto,
    actualizarFoto,
} from "./usuariosCuenta.api"

export const usuarioCrear = async (dataPOST: Record<string, unknown>): Promise<UsuarioCrearResult | undefined> => {
    try {

        const res = await httpClient.post("api/usuario/Agregar", dataPOST)
        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                usuario: res.data.username,
                message: res.data.message,
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                usuario: "",
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            usuario: "",
            message: "Error en el servidor",
        };
    }
}

export const usuariosBuscar = async (dataPOST: UsuarioBuscarRequest): Promise<UsuariosResult | undefined> => {
    try {
        const res = await httpClient.post("api/usuario/BuscarUsuario", dataPOST)
        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                usuarios: res.data.resultado,
                message: res.data.message,
            }
        }

    } catch (error) {
        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                usuarios: [],
                message: error.response.data.message,
            };
        }
        return {
            status: -1,
            usuarios: [],
            message: "Error en el servidor",
        }
    }
}

export const usuarioDelete = async (dataPOST: UsuarioIdRequest): Promise<UsuarioSimpleResult | undefined> => {
    try {

        const res = await httpClient.post("api/usuario/EliminarUsuario", dataPOST)
        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
            }
        }
    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
        }
    }
}

export const usuarioMostrar = async (dataPOST: UsuarioIdRequest): Promise<UsuarioMostrarResult | undefined> => {
    try {

        const res = await httpClient.post("api/usuario/MostrarUsuario", dataPOST)

        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                usuario: res.data.usuario,
                message: res.data.message,
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                usuario: {},
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            usuario: {},
            message: "Error en el servidor",
        }
    }
}

export const usuarioEditar = async (dataPOST: Record<string, unknown>): Promise<UsuarioSimpleResult | undefined> => {
    try {

        const res = await httpClient.post("api/usuario/ActualizarUsuario", dataPOST)
        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
        }
    }
}

export const usuarioListarTodosPorCompania = async (dataPOST: UsuarioBuscarRequest): Promise<UsuariosResult | undefined> => {
    try {

        const res = await httpClient.post("api/usuario/ListarUsuario", dataPOST)

        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
                usuarios: res.data.lista
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
                usuarios: []
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
            usuarios: []
        }
    }
}

